export { default as DocumentPdfSolidIcon } from './DocumentPdfSolidIcon';
